import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
 import { CarouselConfig } from 'ngx-bootstrap/carousel';
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { CookieService } from "ngx-cookie-service";
import { NgxSpinnerService } from "ngx-spinner";
import { UserService } from 'src/app/services/UserService';
import { ApiService } from "src/app/services/api.service";
import { CacheService } from "src/app/services/cache.service";
import { SearchData } from "src/app/services/searchData";
import { UtilService } from "src/app/services/util.service";
import { SocketService } from "src/app/services/socket.service";
import { SocketServiceStream } from "src/app/services/SocketServiceStream";
import { GigsumoConstants } from "src/app/services/GigsumoConstants";
import { FormValidation } from "src/app/services/FormValidation";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { CustomValidator } from "../../Helper/custom-validator";
import { MessageService } from "src/app/services/message.service";

export function toQueryParams(obj : any) {
  return Object.entries(obj)
    .map(([key, value] : any) => 
      encodeURIComponent(key) + '=' + encodeURIComponent(value)
    )
    .join('&');
}


@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss", "../../../../assets/newassets/custom.css",
    "../../../../assets/newassets/bootstrap/css/bootstrap.min.css"],
  providers: [
    { provide: CarouselConfig, useValue: { interval: 10000, noPause: true, showIndicators: true } }
  ]
})
export class LoginComponent extends FormValidation implements OnInit, AfterViewInit {

  @ViewChild('usernameInput') usernameInput!: ElementRef;

  loginForm: UntypedFormGroup;
  submitted: false;
  userId: any;
  cookieValue: any;
  passwordShown = false;
  passwordShown1 = false;
  modalRef: BsModalRef
  queryErr = false;
  inviteDisable = false;
  formComplete;
  redirectTo = null;
  loginbtnDisable=false;
  slides = [
    {
      img: 'assets/newassets/login/Gigsumo_Landingimag.png',
      title: '',
      subtitle: ''
    },
    // {
    //   img: 'assets/newassets/login/one-1.gif',
    //   title: '',
    //   subtitle: ''
    // },
    // {
    //   img: 'assets/newassets/login/two-2.gif',
    //   title: '',
    //   subtitle: ''
    // },
    // {
    //   img: 'assets/newassets/login/three-3.gif',
    //   title: '',
    //   subtitle: ''
    // },
    // {
    //   img: 'assets/newassets/login/four-4.gif',
    //   title: '',
    //   subtitle: ''
    // },
    // {
    //   img: 'assets/newassets/login/five-5.gif',
    //   title: 'five',
    //   subtitle: ''
    // }
  ];
  constructor(
    private fb: UntypedFormBuilder,
    private API: ApiService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private util: UtilService,
    private route: ActivatedRoute,
    private cookieService: CookieService,
    private cache: CacheService,
    private userService: UserService,
    public message: MessageService,
    private modalService: BsModalService,
    private searchData: SearchData,
    private socketService: SocketService,
    private socketServiceStream: SocketServiceStream,

  ) {
    super();
    this.googleLoginUrl = environment.googleRedirectUri;
  }


  ngOnInit() {

    this.checkQueryParams();
    this.message.success("SignIn component");
    this.loginForm = this.fb.group({
      username: [
        null,
        [
          Validators.required,
          Validators.email, CustomValidator.max(this.EMAIL.max),
          Validators.pattern(this.EMAIL.pattern),
        ],
      ],
      password: [null, Validators.required],
    }, { validators: this.apiErrorValidator() });

    this.API.handleErrorOld();
    // window.scrollTo(0, 0);

  }

  ngAfterViewInit(): void {
    this.util.stopLoader();
    setTimeout(function () {
      window.scrollTo(0, 0);
      // if(this.modalService!=undefined){
      // this.modalRef.hide()
      // this.modalService.
      // }
    }, 500);
    this.usernameInput.nativeElement.focus();
    this.modalService.hide(1);
    this.modalService.hide(2);
  }

  checkQueryParams(): void {
    this.route.queryParams.subscribe((res: any) => {
      console.log(res);
       
      if (res) {
        if (res.ruser && res.ruser === "1") {
          this.queryErr = true; 
        }
        // Only take the data-blob branch when a `data` param is actually
        // present (share-link format: redirectTo=/newjobs&absolutePath=true
        // &data={…json…}). Inline-param links like
        // redirectTo=/personalProfile?userId=… carry absolutePath=true but
        // NO data — without this guard, JSON.parse(undefined) throws here,
        // kills the queryParams subscription, leaves redirectTo null and
        // dumps the user on landingPage instead of the profile.
        if(res.absolutePath && res.data){
          this.redirectTo = `${res.redirectTo}?${toQueryParams(JSON.parse(res.data))}`;
        }
        else if (res.redirectTo && res.redirectTo != '') {
          this.redirectTo =  res.redirectTo; 
        }
      }
    });
  }

  


  get login() {
    return this.loginForm.controls;
  }

  apiErrorValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return null;
    };
  }

  setApiError(message: string): void {
    this.loginForm.setErrors({ apiError: message });
  }

  clearApiError(): void {
    if (this.loginForm.errors) {
      delete this.loginForm.errors['apiError'];
      if (Object.keys(this.loginForm.errors).length === 0) {
        this.loginForm.setErrors(null);
      }
    }
  }

  @HostListener('document:keypress', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === "Enter") {
      if (this.loginForm.valid && !this.loginbtnDisable) {
        this.loginform();
      }
    }
  }

  googleLoginUrl: string;
  redirectToGoogle() {
    window.location.href = this.googleLoginUrl;
  }

  redirectTolinkedin() {
    window.location.href = this.googleLoginUrl;
  }



  timedelay(){
    setTimeout(() => {
      this.loginbtnDisable=false;
    }, 2000);
  }
  loginform() {

    if (this.loginbtnDisable) {
      return
    }

    this.queryErr = false;
    this.inviteDisable = true;
    this.clearApiError();
    this.loginForm.markAllAsTouched();
    if (this.loginForm.valid) {
      this.loginbtnDisable = true;
      if (this.loginForm.valid && this.loginbtnDisable) {

        this.util.startLoader();
        this.API.userLogin("home/login", this.loginForm.value).subscribe((res) => {
          this.util.stopLoader();
          this.timedelay();

          if (res && res.code === "00000") {
            this.userId = res.data.userId;
            localStorage.setItem("userId", this.userId);
            this.userService.onlineAPI('ONLINE');

            this.socketService.initiateConnection();
            this.socketServiceStream.initiateConnection();

            this.cookieValue = this.cookieService.set("userId", this.userId);
            this.cookieService.set("userId", this.userId);

            localStorage.setItem("sessionID", this.util.encrypt(res.data.sessionId));
            localStorage.setItem('token', res.data.token);
            localStorage.setItem("userName", this.loginForm.value.username);
            // Persist firstName so the dashboard welcome banner can show the
            // greeting name instantly on first paint, instead of waiting for
            // the user/{id} API round-trip.
            const loginFirstName = res.data?.userData?.firstName ?? res.data?.firstName ?? '';
            if (loginFirstName) {
              localStorage.setItem('firstName', String(loginFirstName).trim());
            }
            // Persist timezone right after login so the dashboard can render
            // dates in the user's zone on first paint, instead of waiting for
            // the user/{id} API round-trip to set `timezonedate`.
            const loginTimeZone = res.data?.userData?.timeZone ?? res.data?.timeZone ?? '';
            if (loginTimeZone) {
              localStorage.setItem('timezonedate', String(loginTimeZone).trim());
            }

            const userType = res.data.userType;
            const userId = res.data.userId
            this.userService.setUserData({ userType, userId });
            if (res.data.lastLoggedIn != null || res.data.lastLoggedIn != undefined) {
              localStorage.setItem('lastLogged', res.data.lastLoggedIn);
            }

            localStorage.setItem('userGuidelines', JSON.stringify(res.data.userGuidelines));
            document.cookie = "userId=" + this.userId;

            this.cache.setValue("userId", this.userId);
            this.inviteDisable = false;
            this.message.success("SignIn successfully");
            // Hydrate `myBusinessId` BEFORE routing — dashboards and a
            // few other landing surfaces read it from localStorage on
            // first render. We call `business/findUserRoleInBusiness/
            // {userId}` directly here and, when the response carries a
            // `businessData.businessId`, persist it to localStorage so
            // the very first dashboard paint can read it. Silent skip
            // for users without a business (free / personal accounts —
            // they won't have a `businessData` in the response). The
            // loader stays on for the duration so the user doesn't land
            // on a page mid-fetch; either next or error path falls
            // through to `proceedToRoute()` so routing always happens.
            this.util.startLoader();
            const proceedToRoute = () => {
              this.util.stopLoader();
            if (res.data.profileStatus === "INCOMPLETED") {
              this.stopMultipleClick();
              const data: any = {};
              data.userId = this.userId;
              this.router.navigate(["userClassification"], { queryParams: data });
            } else if (
              res.data.profileStatus ||
              res.data.profileStatus == null ||
              res.data.profileStatus === "COMPLETED"
            ) {
              if (this.redirectTo != undefined && this.redirectTo != null && this.redirectTo != '') {
                this.stopMultipleClick();
                this.router.navigateByUrl(this.redirectTo);
              } else if (res.data.userStatus === "INITIATED" && res.data.source == "ADMIN_ONBOARD") {
                this.stopMultipleClick();
                const onboarddata: any = {};
                onboarddata.userType = res.data.userType;
                onboarddata.userId = res.data.userId
                onboarddata.firstName = res.data.userData.firstName
                onboarddata.lastName = res.data.userData.lastName
                onboarddata.username = res.data.userData.email
                onboarddata.skipValidation = true
                onboarddata.email = res.data.userData.email
                onboarddata.firstLogin = true
                onboarddata.workExperience = []
                onboarddata.source = res.data.source;
                onboarddata.createdBy = res.data.createdBy
                onboarddata.appAccessStatus = "ACTIVE"
                this.util.startLoader();
                this.API.create("user/saveUser", onboarddata).subscribe(saveRes => {
                  this.stopMultipleClick();
                  if (saveRes.code == '00000') {
                    localStorage.setItem('userType', onboarddata.userType);
                    localStorage.setItem('GSSID', saveRes.gigsumoNo);
                    var data: any = {};
                    data.showWelcomePost = true
                    setTimeout(() => {
                      this.util.stopLoader();
                      this.router.navigate(["landingPage"], { queryParams: data });

                      if (res.data && res.data.ACTIVE_SESSION) {
                        Swal.fire({
                          title: "Multiple Logins Detected",
                          text: "More than one login detected for the same user. As a security measure, we are closing the previous session.",
                          focusConfirm: false,
                          confirmButtonText: "Ok",
                          allowOutsideClick:false,
                          confirmButtonAriaLabel: "Ok",
                        });
                      }

                    }, 2000);



                  } else {
                    this.util.stopLoader()
                    Swal.fire({
                      icon: "info",
                      title: "Oops..",
                      text: 'Something went wrong. Please, try after some time.',
                      showConfirmButton: false,
                      timer: 3000,
                    })
                  }
                }, err => {
                  this.util.stopLoader()
                })
              } else {
                this.stopMultipleClick();
                //implementing the first g-tag for tracking
                this.router.navigate(["landingPage"]);
                setTimeout(() => {
                  if (res.data && res.data.ACTIVE_SESSION) {
                    Swal.fire({
                      title: "Multiple Logins Detected",
                      text: "More than one login detected for the same user. As a security measure, we are closing the previous session.",
                      focusConfirm: false,
                      allowOutsideClick:false,
                      confirmButtonText: "Ok",
                      confirmButtonAriaLabel: "Ok",
                    });
                  }
                }, 2000);
                // this.gtag.event('login', {
                //   'app-name': 'Gigsumo',
                //   'screen-name': 'landing-page'
                // })
              }

              var val: any = {}
              val.isLoggedOut = false
              this.searchData.setCommonVariables(val)
            }

            // this.loadTalentPoolData();
            this.loadSuggestedData();
            };  // end proceedToRoute
            this.API.query(`business/findUserRoleInBusiness/${this.userId}`).subscribe({
              next: (businessRes: any) => {
                const businessId = businessRes?.code === '00000'
                  && businessRes?.data?.businessData?.businessId;
                if (businessId) {
                  localStorage.setItem('myBusinessId', businessId);
                }
                proceedToRoute();
              },
              error: () => proceedToRoute()
            });

          } else if (res.code === "99999") {
            this.inviteDisable = false;
            this.setApiError("Please enter valid email address and password");


            // Already data clear
            this.cookieService.deleteAll();
            let allCookies = document.cookie.split(";");
            if (allCookies) {
              for (let i = 0; i < allCookies.length; i++) {
                document.cookie =
                  allCookies[i] + "=;expires=" + new Date(0).toUTCString();
              }
            }
            localStorage.clear();

          } else if (res.code === GigsumoConstants.BLOCKED_CODE) {
            this.util.blocked();
          }
          else if (res.code === GigsumoConstants.INTERRUPTED) {
            this.util.interrupted();
          }
        }, err => {
          this.loginbtnDisable=false;
          this.util.stopLoader();
        });

      }


    }

  }

  stopMultipleClick(){
    setTimeout(() => {
      this.loginbtnDisable = false;
    }, 2000);
  }

  loadTalentPoolData() {
    let payload : any = {};
    payload.userId = localStorage.getItem('userId');
    payload.limit = 10;

    console.log('[new jobs] API Call with payload:', payload);

    const sub = this.API.create('jobs/triggerMatchInsight', payload).subscribe(
      res => {
        console.error('talent pool data trigger success');        
      },
      err => {
        console.error('talent pool data trigger error : ', err);        
      }
    );
  }

  loadSuggestedData() {

    const userId = localStorage.getItem('userId');

    const sub = this.API.create('home/prepareSuggestedData/'+userId,{}).subscribe(
      res => {
        console.error('talent pool data trigger success');        
      },
      err => {
        console.error('talent pool data trigger error : ', err);        
      }
    );
  }


}
